import { render, staticRenderFns } from "./lsIconPhoneCall.vue?vue&type=template&id=51db8714&scoped=true&"
import script from "./lsIconPhoneCall.vue?vue&type=script&lang=js&"
export * from "./lsIconPhoneCall.vue?vue&type=script&lang=js&"
import style0 from "./lsIconPhoneCall.vue?vue&type=style&index=0&id=51db8714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db8714",
  null
  
)

export default component.exports